module.exports = __webpack_public_path__ + "img/placeholder/gallery/bon-iver-at-montreux-jazz-festival.jpg";